import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import { zodResolver } from '@hookform/resolvers/zod'
import { PostponeTaskSchema } from './PostponeTaskSchema'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import FinalizeTaskDialog from '../FinalizeTaskController/FinalizeTaskDialog'

import styles from '../Dialog.module.sass'
import useSubmitTask from 'hooks/useSubmitTask'
import HFDatepicker from 'components/HFInputs/HFDatepicker'
import moment from 'moment'
import { useRecoilValue } from 'recoil'
import { currentTaskFormState } from 'store/atoms'

const PostponeTaskController = (props) => {
	const { i18n } = useGlobal()
	const { data, resolve, dismiss, id } = props
	const history = useHistory()
	const currentTaskFormData = useRecoilValue(currentTaskFormState)

	const methods = useForm({
		mode: 'onSubmit',
		resolver: zodResolver(PostponeTaskSchema),
	})
	const { handleSubmit, formState } = methods

	const { error, submitting, postponeTask } = useSubmitTask(
		data?.id,
		formState?.errors
	)

	const onSubmit = (formData) => {
		postponeTask({ ...formData, taskFormState: currentTaskFormData })
			.then(() => {
				resolve()
			})
			.catch(() => {})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			{submitting && (
				<FinalizeTaskDialog
					dismiss={dismiss}
					submitting={submitting}
					task={data}
					submissionType={'postpone'}
				/>
			)}
			<FormProvider {...methods}>
				<div className={styles['form-container']}>
					<form
						id={`form_postpone_${id}`}
						className={styles['form']}
						onSubmit={handleSubmit(onSubmit)}
					>
						<fieldset>
							<h4
								className={`${styles['postpone-title']}`}
							>{i18n`Postpone requisition`}</h4>
							<HFDatepicker
								name='dueDate'
								type='datetime-local'
								layout='vertical'
								text={i18n`Date`}
								initialDate={moment()
									.add(1, 'days')
									.startOf('day')}
							/>
						</fieldset>
					</form>
				</div>
			</FormProvider>
			<menu className={styles['menu']}>
				<ActionButton
					key='cancel'
					secondary={true}
					className={styles['menu-button-secondary']}
					onClick={() => {
						history.goBack()
					}}
				>
					{i18n`Cancel`}
				</ActionButton>
				<ActionButton
					className={styles['menu-button-primary-alternate']}
					form={`form_postpone_${id}`}
				>
					{i18n`Postpone`}
				</ActionButton>
			</menu>
		</>
	)
}

export default PostponeTaskController
